/*
 * @Author: ysoshuaibing
 * @Date: 2022-07-18 10:48:27
 * @LastEditors: ysoshuaibing
 * @LastEditTime: 2022-07-18 18:58:48
 */
import SvgIcon from '@/components/SvgIcon/svg-icon.vue';
import VueQr from 'vue-qr/src/packages/vue-qr.vue';
import {
  USolidCaretDown,
  ULineHome,
  ULineDownload,
  ULineClose,
  ULineAdd,
  ULineImport,
  ULineRemove,
  USolidCaretRight,
  ULineCloudUpload,
  ULineSearch,
  ULineReset,
  // USolidHelpCircle,
  ULinePermission,
  ULineConfig,
  ULineSet,
  ULineViewDetail,
  ULineEdit,
  ULineForbid,
  ULinePlayCircle,
  USolidDeleteNormal,
  ULineCopy,
  ULineLoading,
  ULineAddCircle,
  ULineLeft,
  ULineRight,
  USolidAdd,
  URoundEdit,
  ULineDrag,
  USolidDate,
  ULineDelete
} from '@koi-design/uxd-icon';
import EditDialog from '@C/EditDialog.vue';
import DeleteDialog from '@C/DeleteDialog.vue';
import ShortText from '@C/ShortText.vue';
import BotAudio from '@C/FormItem/BotAudio.vue';
import BotCheckBox from '@C/FormItem/BotCheckBox.vue';
import RichMentions from '@C/RichMentions/index.vue';
import BackHome from '@/components/BackHome.vue';
import Avatar from '@C/Avatar/index.vue';
import BotSwitch from '@C/FormItem/BotSwitch.vue';
import Empty from '@C/Empty.vue';
import LongText from '@C/LongText.vue';
import BotIcon from '@C/BotIcon.vue';
import Page from '@C/Page.vue';
import { VixLoading } from '@/components/Loading/index';
import USolidHelpCircle from '@/components/ULineHelpCircle.vue';
import UQueryExampleDelete from '@/components/UQueryExampleDelete.vue';

/**
 * @param app
 */
export function setupCustomComponents(app) {
  app.component(SvgIcon.name, SvgIcon);
  app.component('USolidCaretDown', USolidCaretDown);
  app.component('ULineHome', ULineHome);
  app.component('ULineDownload', ULineDownload);
  app.component('ULineClose', ULineClose);
  app.component('ULineAdd', ULineAdd);
  app.component('ULineImport', ULineImport);
  app.component('ULineSearch', ULineSearch);
  app.component('ULineReset', ULineReset);
  app.component('ULineDelete', ULineDelete);
  app.component('USolidHelpCircle', USolidHelpCircle);
  app.component('ULinePermission', ULinePermission);
  app.component('ULineConfig', ULineConfig);
  app.component('ULineSet', ULineSet);
  app.component('ULineViewDetail', ULineViewDetail);
  app.component('ULineEdit', ULineEdit);
  app.component('ULineForbid', ULineForbid);
  app.component('ULinePlayCircle', ULinePlayCircle);
  app.component('USolidDeleteNormal', USolidDeleteNormal);
  app.component('UQueryExampleDelete', UQueryExampleDelete);
  app.component('ULineCopy', ULineCopy);
  app.component('ULineLoading', ULineLoading);
  app.component('ULineAddCircle', ULineAddCircle);
  app.component('ULineLeft', ULineLeft);
  app.component('ULineRight', ULineRight);
  app.component('USolidAdd', USolidAdd);
  app.component('URoundEdit', URoundEdit);
  app.component('ULineDrag', ULineDrag);
  app.component('USolidDate', USolidDate);
  app.component('ULineRemove', ULineRemove);
  app.component('USolidCaretRight', USolidCaretRight);
  app.component('ULineCloudUpload', ULineCloudUpload);
  app.component('EditDialog', EditDialog);
  app.component('DeleteDialog', DeleteDialog);
  app.component('ShortText', ShortText);
  app.component('BotAudio', BotAudio);
  app.component('BotCheckBox', BotCheckBox);
  app.component('BackHome', BackHome);
  app.component('Avatar', Avatar);
  app.component('BotSwitch', BotSwitch);
  app.component('Empty', Empty);
  app.component('LongText', LongText);
  app.component('BotIcon', BotIcon);
  app.component('Page', Page);
  app.component('RichMentions', RichMentions);
  app.component('VueQr', VueQr);
  app.use(VixLoading);
}
